<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          :command="showMessage"
          :disabled="buttonLoader"
        >
          <i class="el-icon-view" /> Hibaüzenet
        </el-dropdown-item>
        <el-dropdown-item
          v-if="isEdiError"
          :command="showXml"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document" /> XML megtekintése
        </el-dropdown-item>
        <el-dropdown-item
          v-if="canRetry"
          v-can="'errorlog.update'"
          :command="confirmRetry"
          :disabled="buttonLoader"
        >
          <i class="el-icon-refresh" /> Újrapróbálkozás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="relatedRoute"
          v-can="relatedPermission"
          :command="openRelated"
          :disabled="buttonLoader"
        >
          <i class="el-icon-d-arrow-right" /> Kapcsolódó megnyitása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="!errorLog.resolved_at"
          v-can="'errorlog.update'"
          :command="confirmResolve"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" /> Lezárás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="errorLog.errorable_type"
          v-can="'errorlog.update'"
          :command="confirmResolveRelated"
          :disabled="buttonLoader"
        >
          <i class="el-icon-finished" /> Összes kapcsolódó lezárása
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  import { entityRoute, entityPermission, ediErrorableTypes } from '../../views/errorLogs/labels';

  export default {
    props: ['errorLog'],
    data() {
      return {
        buttonLoader: false,
      };
    },
    computed: {
      relatedRoute() {
        return entityRoute(this.errorLog.errorable_type, this.errorLog.errorable_id);
      },
      relatedPermission() {
        return entityPermission(this.errorLog.errorable_type);
      },
      isEdiError() {
        return ediErrorableTypes.includes(this.errorLog.errorable_type);
      },
      canRetry() {
        return this.isEdiError && !this.errorLog.resolved_at;
      },
    },

    methods: {
      showMessage() {
        this.$emit('show-message', this.errorLog);
      },
      showXml() {
        this.$emit('show-xml', this.errorLog.id);
      },
      confirmRetry() {
        this.$confirm('Biztosan újra megpróbálja feldolgozni ezt a rendelést?', 'Újrapróbálkozás', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
          .then(() => this.retry())
          .catch(() => {});
      },
      async retry() {
        // A siker-/hibaüzenetet az axios interceptor jeleníti meg a válasz alapján.
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('errorLog/retry', this.errorLog.id);
        } catch (e) {
          console.error(e);
        }
        this.buttonLoader = false;
      },
      openRelated() {
        if (this.relatedRoute) {
          this.$router.push(this.relatedRoute);
        }
      },
      confirmResolve() {
        this.$confirm('Biztosan lezárja ezt a hibát?', 'Hiba lezárása', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
          .then(() => this.resolve())
          .catch(() => {});
      },
      async resolve() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('errorLog/resolve', this.errorLog.id);
        } catch (e) {
          console.error(e);
        }
        this.buttonLoader = false;
      },
      confirmResolveRelated() {
        this.$confirm('Biztosan lezárja az ehhez a tételhez kapcsolódó összes hibát?', 'Kapcsolódó hibák lezárása', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
          .then(() => this.resolveRelated())
          .catch(() => {});
      },
      async resolveRelated() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('errorLog/resolveRelated', this.errorLog.id);
        } catch (e) {
          console.error(e);
        }
        this.buttonLoader = false;
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
    },
  };
</script>
